var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 70,
    viewBox: "0 0 82 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_591_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 22.4146L40.0832 25.1644L44.6662 18.7482M51.999 21.498C51.999 24.4154 50.8401 27.2133 48.7772 29.2762C46.7143 31.3391 43.9164 32.498 40.999 32.498C38.0816 32.498 35.2837 31.3391 33.2208 29.2762C31.1579 27.2133 29.999 24.4154 29.999 21.498C29.999 18.5806 31.1579 15.7827 33.2208 13.7198C35.2837 11.6569 38.0816 10.498 40.999 10.498C43.9164 10.498 46.7143 11.6569 48.7772 13.7198C50.8401 15.7827 51.999 18.5806 51.999 21.498Z",
    stroke: "#FFBE18",
    strokeWidth: 1.8332,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 15.803L50 37.586L41 43.083L3.757 65.829C4.31423 66.3861 4.97573 66.828 5.70375 67.1295C6.43177 67.431 7.21204 67.5861 8 67.586H74C75.5913 67.586 77.1174 66.9538 78.2426 65.8286C79.3679 64.7034 80 63.1773 80 61.586V15.803Z",
    fill: "#FFBE18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 37.586L2 15.803V61.586C1.99991 62.3739 2.15502 63.1542 2.45649 63.8822C2.75796 64.6102 3.19987 65.2718 3.757 65.829L41 43.083L32 37.586Z",
    fill: "#D9A112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 43.083L32 37.586L2 15.803C1.99988 15.1613 2.20552 14.5364 2.58674 14.0202C2.96795 13.504 3.50465 13.1236 4.118 12.935L38.354 2.39999C40.0778 1.86867 41.9216 1.86763 43.646 2.39699L77.882 12.937C78.4949 13.1255 79.0312 13.5054 79.4124 14.021C79.7935 14.5366 79.9995 15.1608 80 15.802M41 43.083L50 37.586L80 15.803V61.586C80 63.1773 79.3679 64.7034 78.2426 65.8286C77.1174 66.9538 75.5913 67.586 74 67.586H8C7.21203 67.5861 6.43176 67.431 5.70375 67.1295C4.97573 66.828 4.31422 66.3851 3.757 65.828M41 43.083L3.757 65.828M2 15.802V61.585C1.99991 62.373 2.15502 63.1532 2.45649 63.8812C2.75796 64.6093 3.19987 65.2708 3.757 65.828",
    stroke: "#D2D2D2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_591_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerified);
export default __webpack_public_path__ + "static/media/email-verified.c34a8e1ccfe34bb2f7f0259f31acc387.svg";
export { ForwardRef as ReactComponent };